import { render, staticRenderFns } from "./PsychologistReview.vue?vue&type=template&id=745f76aa&scoped=true&"
import script from "./PsychologistReview.vue?vue&type=script&lang=js&"
export * from "./PsychologistReview.vue?vue&type=script&lang=js&"
import style0 from "./PsychologistReview.vue?vue&type=style&index=0&id=745f76aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f76aa",
  null
  
)

export default component.exports